import { AbstractControl } from '@angular/forms';

/** Parse + pretty-print; returns null if empty or invalid JSON. */
export function tryPrettifyJsonString(raw: string): string | null {
  const trimmed = String(raw ?? '').trim();
  if (trimmed === '') {
    return null;
  }
  try {
    return JSON.stringify(JSON.parse(trimmed), null, 2);
  } catch {
    return null;
  }
}

export function jsonStringValidator(control: AbstractControl) {
  const value = control.value;
  if (value === null || value === undefined) {
    return null;
  }
  const trimmed = String(value).trim();
  if (trimmed === '') {
    return null;
  }
  try {
    JSON.parse(trimmed);
    return null;
  } catch {
    return { jsonString: true };
  }
}
